/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * wellcheck-customer
 * OpenAPI spec version: 0.0.0
 */

/**
 * メールアドレス変更に伴う招待メール再送の結果
 */
export type ContactEditUpdateContactResponseInvitationResend = typeof ContactEditUpdateContactResponseInvitationResend[keyof typeof ContactEditUpdateContactResponseInvitationResend];


export const ContactEditUpdateContactResponseInvitationResend = {
  not_needed: 'not_needed',
  sent: 'sent',
  failed: 'failed',
} as const;
